module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-timetable vue-timetable-list-mode"
  }, _vm._l((_vm.date.list), function(day) {
    return (day.events.length > 0) ? _c('div', {
      staticClass: "vue-timetable-day-container"
    }, [_vm._t("header", function() {
      return [_c('header', [_vm._v("\n        " + _vm._s(_vm._f("moment")(day.date, "dddd DD")) + "\n        " + _vm._s(_vm._f("moment")(day.date, "MMMM")) + "\n        "), _c('span', [_vm._v(_vm._s(_vm._f("moment")(day.date, "DD/MM/YYYY")))])])]
    }, {
      "day": day
    }), _vm._v(" "), _c('ul', _vm._l((day.events), function(event) {
      return _c('li', [_c('span', {
        staticClass: "vue-timetable-event-color",
        style: ({
          backgroundColor: event.color
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "vue-timetable-event-link"
      }, [_c('strong', {
        staticClass: "vue-timetable-event-time"
      }, [_vm._v(_vm._s(_vm._f("moment")(event.date.from, 'HH:mm')))]), _vm._v(" "), _c('span', {
        staticClass: "vue-timetable-event-name"
      }, [_vm._t("default", function() {
        return [_vm._v("\n              " + _vm._s(event.text) + "\n            ")]
      }, {
        "event": event
      })], 2)])])
    }), 0)], 2) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65fd79f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-timetable/components/ListTimetable.vue
// module id = 703
// module chunks = 1